<template>
    <b-modal
        id="modalDotacao"
        v-model="mostrarModalDotacao"
        @show="verificarPermiteAtualizar()"
        @hide="$emit('modalFechado')"
    >
        <div slot="modal-title">
            Dotação Orçamentária
        </div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <div v-if="permiteAtualizar">
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Unidade</label>
                        <b-form-select
                            :options="unidades"
                            v-model="codUnidade"
                            text-field="nome"
                            value-field="codUnidade"
                            @input="$v.codUnidade.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Projeto</label>
                        <b-form-select
                            :options="projetos"
                            v-model="codProjeto"
                            text-field="nome"
                            value-field="codProjeto"
                            @input="$v.codProjeto.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Ação</label>
                        <b-form-select
                            :options="acoes"
                            v-model="codAcao"
                            text-field="nome"
                            value-field="codAcao"
                            @input="$v.codAcao.$touch()"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Justificativa</label>
                        <b-form-textarea
                            v-model="justificativa"
                            :rows="4"
                            @input="$v.justificativa.$touch()"
                            :state="$v.justificativa.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A justificativa é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <div slot="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModalDotacao(false)"
                >Cancelar</b-button
            >
            <b-button
                variant="primary"
                :disabled="$v.$invalid"
                @click.stop="confirmarSalvarDotacao()"
                class="ml-1"
                >Salvar</b-button
            >
        </div>
    </b-modal>
</template>

<script>
import { required, maxValue, minValue } from 'vuelidate/lib/validators'

export default {
    props: {
        despesa: {
            type: Object,
            default: () => ({})
        },

        mostrarModal: {
            type: Boolean,
            default: () => false
        },
        
        servicos: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModalDotacao: false,
            codUnidade: null,
            codProjeto: null,
            codAcao: null,
            unidades: [],
            projetos: [],
            acoes: [],
            justificativa: null,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            perc: {
                decimal: ',',
                thousands: '.',
                prefix: '',
                suffix: '%',
                precision: 5,
                masked: false
            },
            permiteAtualizar: false,
            erros: []
        }
    },

    computed: {
        operacao() {
            switch (this.tipo) {
                case 'I':
                    return 'INSERÇÃO'
                case 'A':
                    return 'ATUALIZAÇÃO'
                default:
                    return 'INDEFINIDO'
            }
        }
    },

    methods: {
        obterUnidades() {
            this.$store.dispatch('addRequest')
            this.servicos.obterUnidades().then(response => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos() {
            this.$store.dispatch('addRequest')
            this.servicos.obterProjetos(this.codUnidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(
                            response.errors,
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes() {
            this.$store.dispatch('addRequest')
            this.servicos
                .obterAcoes(this.codUnidade, this.codProjeto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.acoes = response.data
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        fecharModalDotacao(atualizarTela) {
            this.resetDotacao()
            if (atualizarTela) {
                this.$emit('recarregarDespesas')
            }
        },

        resetDotacao() {
            this.mostrarModalDotacao = false
            this.erros = []
            this.codUnidade = null
            this.codProjeto = null
            this.codAcao = null
            this.unidades = []
            this.projetos = []
            this.acoes = []
            this.justificativa = null
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        verificarPermiteAtualizar() {
            this.$store.dispatch('addRequest')
            this.servicos.permiteAtualizarDespesa(this.despesa.etapaId)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            if (response.data.retorno) {
                                this.preencherForm()
                            } else {
                                this.erros.push(response.data.erro)
                            }
                        } 
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        preencherForm() {
            this.obterUnidades()
            this.codUnidade = this.despesa.codCCusto.slice(13);
            this.codProjeto = this.despesa.codCCusto.slice(0, 5);     
            this.codAcao = this.despesa.codCCusto.slice(6, 12);    
            this.permiteAtualizar = true;      
        },

        confirmarSalvarDotacao() {
            this.$swal({
                title: 'Dotação Orçamentária',
                html: `Confirma a ${
                    this.tipo == 'I' ? 'inserção' : 'atualização'
                } da dotação orçamentária?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvarDotacao()
                }
            })
        },

        salvarDotacao() {
            this.$store.dispatch('addRequest')
            let dotacaoDto = {
                codUnidade: this.codUnidade,
                unidade: this.unidades.filter(u => {
                    return u.codUnidade == this.codUnidade
                })[0].nome,
                codProjeto: this.codProjeto,
                projeto: this.projetos.filter(u => {
                    return u.codProjeto == this.codProjeto
                })[0].nome,
                codAcao: this.codAcao,
                acao: this.acoes.filter(u => {
                    return u.codAcao == this.codAcao
                })[0].nome,
                justificativa: this.justificativa
            }
            this.servicos.atualizarCentroCusto(this.despesa.etapaId, this.despesa.despesaId, dotacaoDto)
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Centro de Custo atualizado',
                                'OK',
                                this.$toastConfig.success
                            ) 
                            this.registroSalvoComSucesso()
                        } else {
                            this.$toast.error(
                                response.errors,
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },

        registroSalvoComSucesso() {
            this.fecharModalDotacao(true)
        }
    },

    watch: {
        mostrarModal() {
            this.mostrarModalDotacao = this.mostrarModal
        },

        codUnidade(newVal, oldVal) {
            if (newVal !== null) {
                this.obterProjetos()
            }
        },

        codProjeto(newVal, oldVal) {
            if (newVal !== null) {
                this.obterAcoes()
            }
        },
    },

    validations: {
        codUnidade: {
            codUnidadeOk() {
                let valido = false
                this.unidades.forEach(unidade => {
                    if (unidade.codUnidade == this.codUnidade) {
                        valido = true
                    }
                })
                return valido
            }
        },
        codProjeto: {
            codProjetoOk() {
                let valido = false
                this.projetos.forEach(projeto => {
                    if (projeto.codProjeto == this.codProjeto) {
                        valido = true
                    }
                })
                return valido
            }
        },
        codAcao: {
            codAcaoOk() {
                let valido = false
                this.acoes.forEach(acao => {
                    if (acao.codAcao == this.codAcao) {
                        valido = true
                    }
                })
                return valido
            }
        },
        justificativa: {
            required
        }
    }
}
</script>
